/**
 * Mehndi favor tags — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_shaadi`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const mehndiFavorTagsPack: ToilePack = {
    slug: 'mehndi-favor-tags',
    category: 'occasions',
    name: 'Mehndi favor tags',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 1024, h: 1024},
    readings: [
        {key: 'thankyou', label: 'Thank you', subject: 'a sheet of six round tags in a 2x3 grid, each with "Thank You" lettered in the middle, a henna paisley ring around the edge and a small punched hole at the top, dashed cut lines between the tags'},
        {key: 'mithai', label: 'Mithai box', subject: 'a sheet of six rectangular tags in a 2x3 grid, each with "Sweet Thanks" lettered in the middle, a small drawn ladoo and a marigold in one corner, dashed cut lines between the tags'},
        {key: 'bangles', label: 'Bangles', subject: 'a sheet of six arched tags in a 2x3 grid, each with "Bangles for You" lettered in the middle, a stack of glass bangles drawn above the words, dashed cut lines between the tags'},
    ],
    styles: [
        {key: 'henna', label: 'Henna line', style: 'fine henna-style linework, paisley and mandala ornament, hand-lettered words', palette: 'deep brown henna ink on warm cream', framing: 'Tags evenly spaced on the page with a cream margin'},
        {key: 'flat', label: 'Flat color', style: 'flat vector illustration, bold clean shapes, smooth gradient-free fills, crisp lettering', palette: 'green, orange, pink and gold, a bright palette', framing: 'Tags evenly spaced on a solid cream ground'},
        {key: 'watercolor', label: 'Watercolor', style: 'soft watercolor illustration, loose edges, floral touches, hand-lettered words', palette: 'marigold, rose and leaf green washes on white paper', framing: 'Tags evenly spaced on the page with a white margin'},
    ],
    directions: ['Pastel', 'Peacocks', 'Gold on black'],
    directionHint: 'try: Pastel',
    seo: {
        title: 'Mehndi Favor Tags: Thank You, Sweet Thanks, Bangles',
        metaDescription: 'Printable mehndi favor tags to print and cut: Thank You, Sweet Thanks and Bangles for You tags, in henna, flat colour and watercolor.',
        h1: 'Mehndi favor tags: thank you, sweet thanks, bangles for you',
        tagline: 'A sheet of six tags per page, each with one short line, in three styles.',
        intro: 'Printable tags for the gifts guests take home from the mehndi: a box of mithai, a set of bangles, a henna cone. Each page is a sheet of six tags with dashed cut lines, and every tag carries one short line. The tags read Thank You, Sweet Thanks or Bangles for You. Type a different line in the direction field and the same sheet carries it.',
        useCases: [
            'a tag tied to a gift bag at the mehndi',
            'a thank you tag for a box of sweets',
            'a tag on a set of bangles',
            'a label for a favour at a family party',
        ],
        faq: [
            {q: 'How many tags are on a sheet?', a: 'Each sheet has six tags in a grid of two by three, with dashed lines between them to cut along.'},
            {q: 'Can I print these at home?', a: 'Yes. Each page is square and print-ready, with a clean margin.'},
            {q: 'Can I change the words?', a: 'Yes. The direction field takes a different line of wording, and the sheet layout stays the same.'},
            {q: 'What are the three styles?', a: 'Henna line is fine brown ink on cream, flat colour is bold shapes in green, orange and pink, and watercolor is soft washes on white.'},
        ],
    },
}
